import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'trimDecimalPoints',
    standalone: false
})
export class TrimDecimalPointsPipe implements PipeTransform {

  transform(value: string): string {
    // Try to parse the string as a floating-point number
    const floatValue = parseFloat(value);

    // Check if the parsed value is a valid number
    if (!isNaN(floatValue)) {
      // Convert it back to a string to handle cases like "1050"
      return floatValue.toString();
    } else {
      // Return the original value if it's not a valid number
      return value;
    }
  }

}
